import { render, staticRenderFns } from "./PowerBiEmbed.vue?vue&type=template&id=d76584b8&scoped=true&lang=%20%20html&"
import script from "./PowerBiEmbed.vue?vue&type=script&lang=js&"
export * from "./PowerBiEmbed.vue?vue&type=script&lang=js&"
import style0 from "./PowerBiEmbed.vue?vue&type=style&index=0&id=d76584b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76584b8",
  null
  
)

export default component.exports